import { component } from "picoapp";

export default component((node) => {
  const form = node.querySelector("form");
  form.addEventListener("submit", handleSubmit);
});

function handleSubmit(e) {
  e.preventDefault();

  const form = document.getElementById("recycle-form");
  const data = new FormData(e.target);
  const email = data.get("email");
  const confirmedEmail = data.get("confirm_email");

  if (!validateEmailAddress(email)) {
    const emailField = form.querySelector("input[name='email']");
    const helperText = emailField.nextElementSibling;
    const errorText = emailField.nextElementSibling.nextElementSibling;
    emailField.classList.add("border-interactive-error");
    helperText.classList.add("hidden");
    errorText.classList.remove("hidden");

    emailField.addEventListener("input", (e) => {
      emailField.classList.remove("border-interactive-error");
      helperText.classList.remove("hidden");
      errorText.classList.add("hidden");
    });

    return;
  }

  if (email !== confirmedEmail) {
    const confirmedEmailField = form.querySelector(
      "input[name='confirm_email']"
    );
    const errorText = confirmedEmailField.nextElementSibling;
    confirmedEmailField.classList.add("border-interactive-error");
    errorText.classList.remove("hidden");

    confirmedEmailField.addEventListener("input", (e) => {
      confirmedEmailField.classList.remove("border-interactive-error");
      errorText.classList.add("hidden");
    });

    return;
  }

  data.delete("confirm_email");

  fetch("https://formspree.io/f/mnnadjgd", {
    method: "POST",
    body: data,
    headers: {
      Accept: "application/json",
    },
  }).then((resp) => {
    if (resp.ok) {
      const formSubmitted = document.getElementById("recycle-form-submitted");
      form.classList.add("hidden");
      formSubmitted.classList.remove("hidden");
      e.target.reset();
    }
  });
}

function validateEmailAddress(input) {
  return /^[a-zA-Z0-9.+_-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(?:\.[a-zA-Z]{2,})?$/gm.test(
    input
  );
}
